function teamsAllowed({ next, store, nextMiddleware }) {
  console.warn("hello from teamsAllowed middleware. This should not have been called");
  nextMiddleware();
}

export default teamsAllowed;
